/**
 * WooCommerce Icons
 *
 * Centralized icon components for WooCommerce product selector.
 * Used in WooProductSelector.js, Source.js, and other components.
 *
 * Icons are loaded from external SVG files via SbUtils.printIcon().
 */

import SbUtils from '../../../Utils/SbUtils';

/**
 * Highlight mouse cursor icon - used in empty selection state
 * Design: Material Design, 24x24, #696D80 fill
 */
export const HighlightMouseCursorIcon = (props) => (
    SbUtils.printIcon('woo-highlight-cursor', props?.customClass || false)
);

/**
 * Link off icon - used in URL search empty state
 * Design: Material Design, 32x32, #1C1B1F fill
 */
export const LinkOffIcon = (props) => (
    SbUtils.printIcon('woo-link-off', props?.customClass || false)
);

/**
 * Close/X icon - used for remove buttons
 * Design: Simple X, 8x8, currentColor stroke
 */
export const CloseIcon = (props) => (
    SbUtils.printIcon('woo-close', props?.customClass || false)
);

/**
 * Tag outline icon - used for product tags
 * Design: mdi:tag-outline, 16x16, #434960 fill
 */
export const TagIcon = (props) => (
    SbUtils.printIcon('woo-tag', props?.customClass || false)
);

/**
 * Folder outline icon - used for product categories
 * Design: folder outline, 18x18, #434960 fill
 */
export const FolderIcon = (props) => (
    SbUtils.printIcon('woo-folder', props?.customClass || false)
);

export default { HighlightMouseCursorIcon, LinkOffIcon, CloseIcon, TagIcon, FolderIcon };
